// src/app/core/http/gemp.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Subject } from 'rxjs';
import { UnsubscribeOnDestroyAdapter } from '@shared';
import { environment } from '@enviroment/environment';
import { DefaultResponse } from '@core/models/Http/DefaultResponse';
import { BusinessGroup } from '@core/models/BusinessGroup';
import { GEMP } from '@core/models/GEMP';
import { GeneralFunctionsService } from '@core/service/generalFunctions.service';
import { HttpMesageHandlerService } from '@core/service/http-mesage-handler';
import { MsgResponse } from '@core/models/MsgResponse';
import { UpsertGempPayload} from "@core/models/Http/Payloads";
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class GEMPService extends UnsubscribeOnDestroyAdapter {
  isTblLoading = true;
  dataChange: BehaviorSubject<GEMP[]> = new BehaviorSubject<GEMP[]>([]);
  dialogData!: GEMP;

  // Notificador para que otras partes (header, etc.) refresquen su info
  private _refreshGroups$ = new Subject<void>();
  readonly refreshGroups$ = this._refreshGroups$.asObservable();
  requestRefreshGroups(): void { this._refreshGroups$.next(); }

  constructor(
    private http: HttpClient,
    private readonly gfs: GeneralFunctionsService,
    private httpMsgHandler: HttpMesageHandlerService
  ) { super(); }

  get data(): GEMP[] { return this.dataChange.value; }
  getDialogData() { return this.dialogData; }

  /** ===== READ ===== */
  getAll(): void {
    this.subs.sink = this.http
      .get<DefaultResponse<GEMP[]>>(
        `${environment.backend_url}CatGrupoEmpresarial/GetGrupoEmpresarial`
      )
      .subscribe({
        next: (res) => {
          this.isTblLoading = false;
          this.dataChange.next(res.data);
        },
        error: (err: HttpErrorResponse) => {
          this.isTblLoading = false;
          this.httpMsgHandler.handleMsg(err);
        },
      });
  }

  // en GEMPService
  getById(id: string) {
    const params = new HttpParams().set('id', id);
    return this.http
      .get<DefaultResponse<BusinessGroup[]>>(
        `${environment.backend_url}CatGrupoEmpresarial/GetGrupoEmpresarial`,
        { params }
      )
      .pipe(
        map(res => ({ ...res, data: res.data?.[0] as BusinessGroup }))
      );
  }

  save(gemp: UpsertGempPayload): void {
    const clean = this.gfs.mayusAcentos(gemp);
    this.http.post(`${environment.backend_url}CatGrupoEmpresarial/UpsertGrupoEmpresarial`, clean)
      .subscribe({
        next: (res) => {
          this.httpMsgHandler.handleMsg(res as MsgResponse);
          this.requestRefreshGroups();
        },
        error: (err: HttpErrorResponse) => this.httpMsgHandler.handleMsg(err),
      });
  }
}
